import LinearProgress from "@material-ui/core/LinearProgress";
import React from "react";
import TitlePage from "../../../app/Title/TitlePage";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
    amountDataTableTemplate,
    percentFourDecimalsDataTableTemplate
} from "../../../utils/formatters/Numbers";
import {Divider} from "@material-ui/core";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import PropTypes from "prop-types";

const BilateralContractView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Bilaterales \ Contrato Bilateral"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            label="Buscar"
                            style={{'float': 'right'}}
                            onClick={props.getDataContracts}
                        />
                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    <Grid item xs={12}>
                        <DataTable
                            responsive={true}
                            value={props.dataBilateralContract}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="borrowerName" header="Institución"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="haircut" header="Aforo"
                                    style={{textAlign: 'left'}}
                                    body={percentFourDecimalsDataTableTemplate}
                                    sortable={true}/>
                            <Column field="threshold" header="Línea de Crédito"
                                    style={{textAlign: 'left'}}
                                    body={amountDataTableTemplate}
                                    sortable={true}/>
                            <Column field="usedThreshold" header="Línea Utilizada"
                                    style={{textAlign: 'left'}}
                                    body={amountDataTableTemplate}
                                    sortable={true}/>
                            <Column field="availableThreshold" header="Línea Disponible"
                                    style={{textAlign: 'left'}}
                                    body={amountDataTableTemplate}
                                    sortable={true}/>
                            <Column header="Acciones"
                                    style={{textAlign: 'center', width: '8em'}}
                                    body={props.bilateralContractActionTemplate}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>

        </React.Fragment>
    )
};

export default BilateralContractView;

BilateralContractView.propTypes = {
    getDataContracts: PropTypes.func.isRequired,
    dataBilateralContract: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    messagesGrowl: PropTypes.object,
    bilateralContractActionTemplate: PropTypes.func.isRequired,
}